export const pricingPlan = [
    { save: 'SAVE 10%', duration: 12, durationValue: 'months', amount: 50000, value: 'YEARLY' },
    { save: 'SAVE 66%', duration: 6, durationValue: 'months', amount: 30000, value: '6-MONTHLY' },
    { save: 'SAVE 33%', duration: 1, durationValue: 'months', amount: 6000, value: 'MONTHLY' },
    { save: 'POPULAR', duration: 1, durationValue: 'week', amount: 2000, value: 'WEEKLY' },
    { save: 'ECO', duration: 1, durationValue: 'day', amount: 500, value: 'DAILY' },
];
